module.exports = __webpack_public_path__ + "static/img/y2.6828ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y2.png
// module id = WcHa
// module chunks = 1